import { css, jsx } from '@emotion/core';
import { Icon } from 'antd';
import React from 'react';

import { bp, colors } from '@/styles';

const styles = {
  step: (last = false) => css`
    flex-shrink: 0;
    flex-grow: ${last ? 0 : 1};
    display: flex;
    flex-direction: column;
    position: relative;
  `,
  stepIcon: index => css`
    color: ${colors.primaryBlue};
    font-size: 32px;
    padding-left: ${index === 0 ? '0px' : '13px'};
    padding-right: 13px;
    @media ${bp.md} {
      padding-right: 0px;
    }
  `,
  stepTopContent: (isActive = false) => css`
    display: flex;
    background-color: white;
    align-items: ${isActive ? 'flex-start' : 'center'};
    @media ${bp.md} {
      align-items: flex-start;
    }
  `,
  stepDescription: (isActive = false, isFinished = false, last = false) => css`
    font-size: 1.6rem;
    color: ${isActive || isFinished ? colors.secondaryGray : colors.accentGrayMedium};
    display: ${isActive ? 'block' : 'none'};
    @media ${bp.md} {
      display: block;
    }
  `,
  stepText: css`
    padding-left: 0px;
    white-space: nowrap;
    width: 100%;
    @media ${bp.md} {
      display: block;
      padding-left: 13px;
    }
  `,
  stepTitle: (isActive, isFinished = false) => css`
    margin-bottom: 0;
    font-weight: 900;
    font-size: 2rem;
    line-height: 32px;
    color: ${isActive || isFinished ? colors.secondaryGreyDark : colors.accentGrayMedium};
    display: ${isActive ? 'block' : 'none'};
    @media ${bp.md} {
      display: block;
    }
  `,
  stepCircle: (isActive, index) => css`
    position: relative; 
    display: flex;
    flex-shrink: 0;
    width: ${!isActive ? '30px' : '32px'};
    height: ${!isActive ? '30px' : '32px'};
    border-radius: 50%;
    margin-left: ${index === 0 ? '0px' : '13px'};
    margin-right: 12px;
    background-color: ${isActive ? colors.secondaryBlue : colors.white};
    ${
      !isActive
        ? css`
            box-shadow: 0 0 0 3px ${colors.accentGrayMedium};
          `
        : null
    }
    @media ${bp.md} {
      margin-right: 0px;
    }
  `,
  stepNumber: isActive => css`
    position: absolute;
    font-weight: 900;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: ${isActive ? colors.white : colors.accentGrayMedium};
  `,
  stepLine: (color, isActive, last = false) => css`
    display: block;
    width: 100%;
    height: 2px;
    display: ${last ? 'none' : 'block'};
    margin-left: 12px;
    background-color: ${color};
  `,
  stepInner: (last = false) => css`
    display: flex;
    align-items: center;
  `,
};
const Step = ({ title, description, currentStep, index, last, onClick, totalNumberOfSteps }) => {
  const isActive = currentStep === index;

  const isFinished = currentStep > index;
  const renderIcon = () => {
    if (currentStep > index) return <Icon type="check-circle" css={styles.stepIcon(index)} />;
    if (currentStep < index)
      return (
        <div css={styles.stepCircle(false, index)}>
          <p css={styles.stepNumber(false)}>{index + 1}</p>
        </div>
      );
    return (
      <div css={styles.stepCircle(true, index)}>
        <p css={styles.stepNumber(true)}>{index + 1}</p>
      </div>
    );
  };
  return (
    <div css={styles.step(last)}>
      <div css={styles.stepTopContent(isActive)}>
        {renderIcon()}
        <div css={styles.stepText}>
          <div css={styles.stepInner(last)}>
            <p css={styles.stepTitle(isActive, isFinished)}>{title}</p>
            <span
              css={styles.stepLine(isFinished ? colors.primaryBlue : '#A8A8AA', isActive, last)}
            />
          </div>
          <p css={styles.stepDescription(isActive, isFinished, last)}>{description}</p>
        </div>
      </div>
    </div>
  );
};
export default Step;
